import { render, staticRenderFns } from "./QuickLinks.vue?vue&type=template&id=869cc38e&scoped=true&"
import script from "./QuickLinks.vue?vue&type=script&lang=ts&"
export * from "./QuickLinks.vue?vue&type=script&lang=ts&"
import style0 from "./QuickLinks.vue?vue&type=style&index=0&id=869cc38e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869cc38e",
  null
  
)

export default component.exports